import { Skeleton } from "@au-schein-de/au-ui-library";

export function MapSkeleton() {
	return (
		<div
			className="relative w-full h-full min-h-[250px] overflow-hidden"
			data-testid="pharmacy-map-skeleton"
		>
			<Skeleton className="w-full h-full bg-gray-200" />
			<div className="absolute top-3 right-3 flex flex-col gap-1">
				<Skeleton className="size-8 bg-gray-300 rounded" />
				<Skeleton className="size-8 bg-gray-300 rounded" />
			</div>
		</div>
	);
}
